// extracted by mini-css-extract-plugin
export default {"flowPlaceholder":"FlowPlaceholder_flowPlaceholder__rLjsD"};